import { api } from './auth.service';

// ════════════════════════════════════════════════════════════════════════════
// acesso.service.js — r93
// ════════════════════════════════════════════════════════════════════════════

const acessoService = {
  // Lista todos os acessos (com filtros opcionais multi-seleção)
  listar: async ({ colaborador_ids = [], cliente_ids = [] } = {}) => {
    const params = { _t: Date.now() };
    if (colaborador_ids.length > 0) params.colaborador_ids = colaborador_ids.join(',');
    if (cliente_ids.length > 0) params.cliente_ids = cliente_ids.join(',');
    const res = await api.get('/acessos', { params });
    return res.data;
  },

  // Próximo seq pra (usuario, cliente)
  proximoSeq: async (colaborador_id, cliente_id) => {
    const res = await api.get('/acessos/proximo-seq', {
      params: { colaborador_id, cliente_id, _t: Date.now() },
    });
    return res.data.seq;
  },

  // Cria N acessos pra mesmo (usuario, cliente)
  criar: async (dados) => {
    // dados = { colaborador_id, cliente_id, acessos: [{ tipo_acesso, descricao, atributos: [{tipo_attr, valor}] }] }
    const res = await api.post('/acessos', dados);
    return res.data;
  },

  // Altera 1 acesso
  alterar: async (id, dados) => {
    // dados = { tipo_acesso, descricao, atributos: [{tipo_attr, valor}] }
    const res = await api.put(`/acessos/${id}`, dados);
    return res.data;
  },

  // Excluir 1 acesso
  excluir: async (id) => {
    const res = await api.delete(`/acessos/${id}`);
    return res.data;
  },

  // ── r243: Arquivo Rdp (um .rdp por acesso) ───────────────────────────────
  // O download passa pelo axios (e não por <a href>) porque a rota é protegida
  // pela permissão de acessos e só o interceptor injeta o x-usuario-id.
  uploadRdp: async (id, file) => {
    const form = new FormData();
    form.append('arquivo', file);
    const res = await api.post(`/acessos/${id}/rdp`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },

  excluirRdp: async (id) => {
    const res = await api.delete(`/acessos/${id}/rdp`);
    return res.data;
  },

  // Baixa o .rdp e dispara o "salvar como" do browser com o nome original.
  baixarRdp: async (id, nomeArquivo) => {
    const res = await api.get(`/acessos/${id}/rdp`, { responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/x-rdp' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo || 'acesso.rdp');
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  },
};

export default acessoService;
